let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("aCh9P"), load("bxxT5"), load("bRMot"), load("ayTqo")]).then(() => parcelRequire('jYGu4'));